// ═══ 말소대행신청 차량번호 줄 (B3 S2 · 차량번호만 신청 Jin 11/04 · 한 화면 simplify) + 차량별 예외 시트 + 부가서비스 칩 ═══
// 줄 1개 = 차 1대 — 번호 텍스트 · '진행 중' 배지(서버 409 CARNO_IN_PROGRESS) · ✕ 빼기 · 차량별 예외 링크(켜졌을 때).
// 줄 안에서 번호를 고치지 않는다(지우고 다시 추가). 입력칸은 화면 위 1개(MalsoRequest).
// 부가서비스 칩은 직접 렌더(ExtraServicePicker 는 한글 고정이라 재사용하지 않는다).
import React, { useState } from 'react';
import { T, R, S, FONT } from '../../theme';
import ConfirmSheet from '../../simple/parts/ConfirmSheet';
import { input as inputSt } from '../../simple/screens/request/bits';
import { serviceEntry } from '../requestLogic';

var cardSt = { background: T.card, border: '1px solid ' + T.bd, borderRadius: R.card, padding: '8px 12px', display: 'flex', flexDirection: 'column', gap: 6 };
var head = { display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 };
var numSt = { flex: 'none', minWidth: 18, fontSize: 12, fontWeight: 700, color: T.faint, textAlign: 'center' };
var carNoSt = { flex: 1, minWidth: 0, fontSize: 14, fontWeight: 800, color: T.ink, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var pill = { flex: 'none', fontSize: FONT.badge, fontWeight: 700, padding: '3px 8px', borderRadius: R.pill, background: T.dangerTint, color: T.danger };
var xBtn = { border: 0, background: 'none', color: T.faint, fontSize: 15, cursor: 'pointer', padding: 4, fontFamily: 'inherit' };
var chips = { display: 'flex', flexWrap: 'wrap', gap: 6 };
var toggleRow = { display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' };
var toggleSub = { display: 'block', fontSize: 11.5, color: T.muted };

/// 부가서비스 칩 — value = services 배열(serviceEntry 모양). props: { options, value, onChange }
export function ServiceChips(props) {
  var ids = props.value.map(function (s) { return s.serviceId; });
  return (<div style={chips}>{props.options.map(function (o) {
    var on = ids.indexOf(o.id) >= 0;
    return (<button key={o.id} type="button" style={on ? S.chipOn : S.chip} aria-pressed={on} data-svc={o.id}
      onClick={function () {
        props.onChange(on ? props.value.filter(function (s) { return s.serviceId !== o.id; }) : props.value.concat([serviceEntry(o)]));
      }}>{o.name}</button>);
  })}</div>);
}

/// props: { t, index(1부터), card, hasOverride, onRemove, onPerCar|null }
function MalsoCarCard(props) {
  var t = props.t;
  var c = props.card;
  return (<div style={cardSt} data-testid={'car-card-' + c.key}>
    <div style={head}>
      <span style={numSt}>{props.index}</span>
      <span style={carNoSt} data-testid={'car-' + c.key + '-carNo'}>{c.carNo}</span>
      {c.exists ? <span style={pill} data-testid={'car-pill-' + c.key}>{t('malsoModeErrCarNoInProgressBadge')}</span> : null}
      <button type="button" style={xBtn} data-testid={'car-remove-' + c.key} aria-label={t('malsoModeRemoveCar')} title={t('malsoModeRemoveCar')}
        onClick={props.onRemove}>✕</button>
    </div>
    {props.onPerCar ? (<button type="button" style={Object.assign({}, S.link, { alignSelf: 'flex-start' })} data-testid={'percar-' + c.key}
      onClick={props.onPerCar}>{t(props.hasOverride ? 'malsoModePerCarOptions' : 'malsoModePerCarUseCommon')}</button>) : null}
  </div>);
}

/// 차량별 예외 — 부가서비스·바이어를 각각 '공통 옵션 사용' 또는 이 차만 따로 (앱 _PerCarSheet).
/// props: { t, card, options, exportCancel, value(override|undefined), onSave(override|null), onClose }
export function PerCarSheet(props) {
  var t = props.t;
  var v = props.value || {};
  var stSvc = useState(v.services || null); var services = stSvc[0], setServices = stSvc[1];
  var stBuyer = useState(typeof v.buyerName === 'string' ? v.buyerName : null); var buyer = stBuyer[0], setBuyer = stBuyer[1];
  var toggle = function (labelKey, common, onCommon, id) {
    return (<label style={toggleRow}>
      <span style={{ flex: 1 }}><b>{t(labelKey)}</b><span style={toggleSub}>{t('malsoModePerCarUseCommon')}</span></span>
      <input type="checkbox" checked={common} data-testid={id} onChange={function (e) { onCommon(e.target.checked); }} />
    </label>);
  };
  var save = function () {
    var ov = {};
    if (services && props.options.length) ov.services = services;
    if (buyer !== null && props.exportCancel) ov.buyerName = buyer.trim();
    props.onSave(Object.keys(ov).length ? ov : null);
  };
  var c = props.card;
  return (<ConfirmSheet open title={t('malsoModePerCarOptions')} sub={c.carNo}
    onConfirm={save} onClose={props.onClose}>
    {props.options.length ? toggle('extraSvcTitle', !services, function (on) { setServices(on ? null : []); }, 'percar-svc-common') : null}
    {props.options.length && services ? <ServiceChips options={props.options} value={services} onChange={setServices} /> : null}
    {props.exportCancel ? toggle('buyersTitle', buyer === null, function (on) { setBuyer(on ? null : ''); }, 'percar-buyer-common') : null}
    {props.exportCancel && buyer !== null ? (<input style={inputSt} list="malso-buyers" value={buyer} data-testid="percar-buyer"
      placeholder={t('malsoModeBuyerHint')} onChange={function (e) { setBuyer(e.target.value); }} />) : null}
  </ConfirmSheet>);
}

export default MalsoCarCard;
